import {
  AlignLeftOutlined,
  CloseCircleOutlined,
  FilterOutlined,
} from '@ant-design/icons'
import { Button, Col, Input, Pagination, Row } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { Fragment, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { withRouter } from 'react-router-dom'
import { TRUC_COMMAND } from '../../command_constant'
import { TableBottomPaginationBlock } from '../../components/Common/Table'
import TableComponent from '../../components/Common/TableComponent'
import NormalTag from '../../components/NormalTag'
import PageTitle from '../../components/PageTitle'
import UserListFilterBlock from '../../components/UserListFilterBlock'
import UserPermissionPanel from '../../components/UserPermissionPanel'
import { systemName } from '../../config'
import ConnectedTrucAccountUserConfigPanel from '../DocumentManagement/ConnectedDocument/ConnectedTrucAccount/ConnectedTrucAccountUserConfigPanel'
import DocumentsLayout from '../UserManagementPage/DocumentsLayout'
import { FilterButton, SearchBar } from './UserAppManagementPageStyled'
import {
  MagnifierOutlineIcon,
  SettingsOutlineIcon,
} from '../../components/AppIcon'
import UserAccountManagementPageAdvanceFilterV2 from '../UserAccountManagementPage/UserAccountManagementPageAdvanceFilterV2'
import { AppTable } from '../../components/AppTable/AppTable'
import { blue } from '../../color'
import { AppTablePagination } from '../../components/AppTable/AppTablePagination'
import AppPageHeader from '../../components/AppPageHeader'

const { Search } = Input

const UserAppManagementPage = props => {
  const {
    userStore,
    loadingAnimationStore,
    authenticationStore,
    history,
    accountEditStore,
  } = props

  const {
    userListPageIndex,
    userListPageSize,
    userListKeyword,
    userListStatus,
    userListDepartmentCode,
    userListSortDirection,
    userListSortBy,
  } = userStore

  const [showUserInfo, setShowUserInfo] = useState(false)
  const [showFilter, setShowFilter] = useState(false)
  const [
    isVisibleConnectedTrucConfigPanel,
    setIsVisibleConnectedTrucConfigPanel,
  ] = useState(false)

  const handleChangePage = (page, size) => {
    userStore.changeUserListPageIndex(page - 1)
    userStore.changeUserListPageSize(size || 10)
  }

  useEffect(() => {
    if (!showUserInfo) {
      document.getElementsByTagName('body')[0].style.overflow = 'auto'
    }
  }, [showUserInfo])

  const handleViewUserInfo = userInfo => {
    loadingAnimationStore.showSpinner(true)
    Promise.all([
      userStore.setSelectedUser(userInfo),
      accountEditStore.getAccountsByUserCode(userInfo.code),
    ])
      .then(() => setShowUserInfo(true))
      .finally(() => loadingAnimationStore.showSpinner(false))
  }

  const handleCloseUserInfoModal = () => {
    userStore.clearSelectedUser()
    setShowUserInfo(false)
  }

  const handleShowAdvancedFilter = status => {
    setShowFilter(status)
    if (!status) {
      userStore.clearUserListFilter()
    }
  }

  const handleShowConnectedTrucConfigPanel = userInfo => {
    loadingAnimationStore.showSpinner(true)
    Promise.all([
      userStore.setSelectedUser(userInfo),
      accountEditStore.getAccountsByUserCode(userInfo.code),
      accountEditStore.getCommandsByUser(userInfo.code),
    ])
      .then(() => setIsVisibleConnectedTrucConfigPanel(true))
      .finally(() => loadingAnimationStore.showSpinner(false))
  }

  const handleCloseConnectedTrucConfigPanel = () => {
    setIsVisibleConnectedTrucConfigPanel(false)
  }

  useEffect(() => {
    if (authenticationStore.currentUser) {
      loadingAnimationStore.showSpinner(true)
      // userStore.setFilter('userListHasAdmin', true)
      userStore.setFilter(
        'companyCode',
        userStore.companyCodeCurrent || authenticationStore.currentCompanyCode()
      )
      userStore
        .getUserList()
        .finally(() => loadingAnimationStore.showSpinner(false))
    }
  }, [
    userListPageIndex,
    userListPageSize,
    userListKeyword,
    userListStatus,
    userListDepartmentCode,
    userListSortDirection,
    userListSortBy,
    loadingAnimationStore,
    userStore,
    authenticationStore.currentUser,
    userStore.companyCodeCurrent,
  ])

  useEffect(() => {
    return () => {
      userStore.clearStore()
    }
  }, [])

  const actionColumn = !props.isDocumentManagementTab
    ? {
        title: 'Tác vụ',
        align: 'center',
        width: 80,
        key: 'action',
        render: record => (
          <Button
            onClick={() => handleViewUserInfo(record)}
            icon={
              <SettingsOutlineIcon
                style={{
                  width: 18,
                  height: 18,
                  color: blue,
                }}
              />
            }
            type="text"
            shape="circle"
            title="Cấu hình"
          />
        ),
      }
    : {
        title: 'Tác vụ',
        width: 80,
        align: 'center',
        key: 'action',
        render: record => (
          <Button
            onClick={() => handleShowConnectedTrucConfigPanel(record)}
            icon={
              <SettingsOutlineIcon
                style={{
                  width: 18,
                  height: 18,
                  color: blue,
                }}
              />
            }
            type="text"
            shape="circle"
            title="Cấu hình"
          />
        ),
      }

  const tableColumns = [
    {
      title: 'Họ tên',
      width: 240,
      key: 'fullname',
      render: record => (
        <strong style={{ textTransform: 'capitalize' }}>
          {record.name_lowercase}
        </strong>
      ),
    },
    {
      width: 240,
      title: 'Username',
      key: 'username',
      render: record => record.username,
    },
    {
      title: 'Phần mềm',
      width: 240,
      key: 'portal',
      render: record =>
        record.commands.length !== 0 ? (
          <NormalTag tags={record.commands.map(command => command.name)} />
        ) : (
          'Không có'
        ),
    },
    actionColumn,
  ]

  useEffect(() => {
    if (!authenticationStore.currentUser) return
    // if (
    //   authenticationStore.currentUser
    //   && authenticationStore.currentUser.roles.includes('SUPER_ADMIN')
    // ) return
    // history.push('/')
    // message.error('Bạn không có quyền truy cập trang này, vui lòng liên hệ admin')
  }, [authenticationStore.currentUser, history])

  return (
    <>
      {!props.isDocumentManagementTab ? (
        <DocumentsLayout
          title={
            <AppPageHeader
              title="Quản lý phần mềm"
              addon={
                <>
                  <Search
                    allowClear
                    onSearch={userStore.changeUserListKeyword}
                    placeholder={'Tìm kiếm theo username'}
                    maxLength={500}
                    enterButton={
                      <MagnifierOutlineIcon
                        style={{ color: '#000', width: 16, height: 16 }}
                      />
                    }
                    className="custom-search-input fixed-width"
                  />

                  <UserAccountManagementPageAdvanceFilterV2 />
                </>
              }
            />
          }
          selectedKey={'user-app-management'}>
          <Helmet>
            <title>Quản lý phần mềm | {systemName} Portal</title>
          </Helmet>

          <AppTable
            rowKey={record => record.code}
            dataSource={userStore.userHasAdminList}
            columns={tableColumns}
            pagination={false}
            scroll={{ x: 640 }}
          />

          <AppTablePagination
            onChange={handleChangePage}
            pageSize={userListPageSize}
            showLessItems
            current={userListPageIndex + 1}
            total={userStore.userListTotalCount}
            hideOnSinglePage={false}
          />
        </DocumentsLayout>
      ) : (
        <>
          <Row>
            <Col span={12}>
              {' '}
              <Search
                allowClear
                onSearch={userStore.changeUserListKeyword}
                placeholder={'Tìm kiếm theo username'}
                maxLength={500}
                enterButton={
                  <MagnifierOutlineIcon
                    style={{ color: '#000', width: 16, height: 16 }}
                  />
                }
                className="custom-search-input fixed-width"
              />
            </Col>
            <Col span={12} style={{ textAlign: 'right' }}>
              <UserAccountManagementPageAdvanceFilterV2 />
            </Col>
          </Row>

          <AppTable
            rowKey={record => record.code}
            dataSource={userStore.userHasAdminList}
            columns={tableColumns}
            pagination={false}
            scroll={{ x: 640 }}
          />

          <AppTablePagination
            onChange={handleChangePage}
            pageSize={userListPageSize}
            showLessItems
            current={userListPageIndex + 1}
            total={userStore.userListTotalCount}
            hideOnSinglePage={false}
          />
        </>
      )}
      <UserPermissionPanel
        drawerVisible={showUserInfo}
        onClose={handleCloseUserInfoModal}
      />

      <ConnectedTrucAccountUserConfigPanel
        selectedCommandCode={TRUC_COMMAND}
        drawerVisible={isVisibleConnectedTrucConfigPanel}
        onClose={handleCloseConnectedTrucConfigPanel}
      />
    </>
  )
}

export default withRouter(
  inject(
    'userStore',
    'loadingAnimationStore',
    'authenticationStore',
    'accountEditStore'
  )(observer(UserAppManagementPage))
)
